export const fadeInRight = {
  hidden: {
    opacity: 0,
    right: "-100%",
  },
  visible: {
    opacity: 1,
    right: "0%",
    transition: {
      type: "spring",
    },
  },
};

export const fadeInTop = {
  hidden: {
    opacity: 0,
    y: -15,
    marginBottom: 0,
  },
  visible: {
    opacity: 1,
    y: 10,
    marginBottom: 0,
    transition: {
      opacity: { duration: 0.25, delay: 0.05 },
      y: { duration: 0.6, ease: "easeOut" },
    },
  },
};
